import {MdAccountCircle, MdExpandLess, MdExpandMore} from 'react-icons/md';
import type {User} from './types';
import {getUserDisplayName} from './utils';

export type UserNameSectionProps = {
  user: User;
  isExpanded: boolean;
  onToggleExpanded?: () => void;
};

export const UserNameSection: React.FC<UserNameSectionProps> = ({
  user,
  isExpanded = false,
  onToggleExpanded,
}) => {
  const displayName = getUserDisplayName(user);

  return (
    <div className="flex flex-col justify-between flex-1 h-full">
      <div className="flex items-center gap-4">
        <div className="flex-shrink-0">
          <MdAccountCircle size={20} />
        </div>
        <div className="font-bold min-w-0">{displayName}</div>
      </div>
      {onToggleExpanded && (
        <button
          type="button"
          onClick={onToggleExpanded}
          className="flex items-center gap-1 text-primary text-sm hover:underline self-end justify-end"
        >
          <span>{isExpanded ? '閉じる' : 'もっとみる'}</span>
          {isExpanded ? <MdExpandLess size={16} /> : <MdExpandMore size={16} />}
        </button>
      )}
    </div>
  );
};
